import React from 'react'
import { appConfig } from '../../assets/customizations/config'

const HealthSpringLoginSection: React.FC = () => (
  <section className="healthspring-login-section">
    <h3 className='h4 fw-semibold'>FHIR Endpoint Management</h3>
    <p>The HealthSpring portal for managing FHIR endpoints and interoperability.</p>
    <hr />
    <h4 className='fw-semibold'>Are you a HealthSpring Member?</h4>
    {appConfig.login_link ? (
      <a href={appConfig.login_link} target="_blank" rel="noreferrer">Log In Here</a>
    ) : null}
  </section>
)

export default HealthSpringLoginSection